/**
 * Upsellkasten "Meist zusammengekauft" auf der Produktseite.
 * Blaettert durch die Zubehoerprodukte und legt sie in den Warenkorb.
 */
if (!customElements.get('upsell-zubehoer')) {
  customElements.define(
    'upsell-zubehoer',
    class extends HTMLElement {
      connectedCallback() {
        this.folien = Array.from(this.querySelectorAll('.upsell__folie'));
        this.zaehler = this.querySelector('[data-aktuell]');
        this.index = 0;
        if (!this.folien.length) return;

        this.addEventListener('click', (e) => {
          const pfeil = e.target.closest('.upsell__pfeil');
          if (pfeil) return this.blaettern(pfeil.dataset.richtung === 'vor' ? 1 : -1);

          const kaufen = e.target.closest('.upsell__knopf--kaufen');
          if (kaufen && !kaufen.disabled) return this.inDenWarenkorb(kaufen);
        });
      }

      blaettern(schritt) {
        // Rundlauf, damit man nicht in einer Sackgasse landet
        this.index = (this.index + schritt + this.folien.length) % this.folien.length;
        this.folien.forEach((f, i) => f.classList.toggle('ist-aktiv', i === this.index));
        if (this.zaehler) this.zaehler.textContent = this.index + 1;
      }

      inDenWarenkorb(knopf) {
        const id = knopf.dataset.variante;
        if (!id) return;
        const beschriftung = knopf.textContent;
        knopf.disabled = true;
        knopf.textContent = 'Wird hinzugefügt …';

        const url = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
        fetch(url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then((a) => a.json())
          .then(() => {
            knopf.textContent = '✓ Im Warenkorb';
            knopf.classList.add('ist-erledigt');
            // Dasselbe Ereignis wie beim Warenkorbknopf der Produktseite,
            // damit Warenkorbzaehler und Schublade sich aktualisieren.
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true })
            );
            window.setTimeout(() => {
              knopf.textContent = beschriftung;
              knopf.classList.remove('ist-erledigt');
              knopf.disabled = false;
            }, 2500);
          })
          .catch(() => {
            knopf.textContent = beschriftung;
            knopf.disabled = false;
          });
      }
    }
  );
}
